import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import wechatIcon from '../icon/wechat.svg';
import logo from '../icon/logo.svg';
import qrcode from '../icon/qrcode.gif';

const Footer: React.FC = () => {
  const { i18n } = useTranslation();
  const [showQRCode, setShowQRCode] = useState(false);
  
  return (
    <>
      <footer className="bg-black text-white">
        {/* PC Footer - height 105px */}
        <div className="max-w-[2000px] mx-auto hidden md:block" style={{ height: '105px' }}>
          <div className="flex flex-col h-full">
            <div className="flex justify-between items-center flex-grow px-4 md:px-12">
              <div className="text-gray-400 text-base">
                © 2025 {i18n.language === 'en' ? 'DonDA International' : '东大国际'}. 
                {i18n.language === 'en' ? 'All rights reserved.' : '版权所有。'}
              </div>
              <div className="flex items-center gap-8">
                <Link to="/about" className="text-gray-400 hover:text-white text-base">
                  {i18n.language === 'en' ? 'About Us' : '关于我们'}
                </Link>
                <button 
                  onClick={() => setShowQRCode(true)}
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                >
                  <img src={wechatIcon} alt="WeChat" className="w-[30px] h-auto" />
                </button>
              </div>
            </div>
            <div className="border-t border-gray-800 mt-auto"></div>
          </div>
        </div>

        {/* Mobile Footer - height 142px */}
        <div className="max-w-[2000px] mx-auto md:hidden" style={{ height: '142px' }}>
          <div className="flex flex-col h-full px-4">
            <div className="flex justify-center items-center py-4 gap-8">
              <Link to="/about" className="text-gray-400 hover:text-white text-base">
                {i18n.language === 'en' ? 'About Us' : '关于我们'}
              </Link>
              <button 
                onClick={() => setShowQRCode(true)}
                className="cursor-pointer hover:opacity-80 transition-opacity"
              >
                <img src={wechatIcon} alt="WeChat" className="w-[30px] h-auto" />
              </button>
            </div>
            <div className="border-t border-gray-800"></div>
            <div className="flex-grow flex items-center justify-center">
              <div className="text-gray-400 text-base text-center">
                © 2025 {i18n.language === 'en' ? 'DonDA International' : '东大国际'}. 
                {i18n.language === 'en' ? 'All rights reserved.' : '版权所有。'}
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* QR Code Modal */}
      {showQRCode && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div 
            className="relative bg-white rounded-lg p-8 w-[480px] mx-4 flex flex-col justify-center"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h30v30H0zM30 30h30v30H30z' fill='%23f8f8f8'/%3E%3Cpath d='M0 0h15a15 15 0 0 1 0 30H0zM30 30h15a15 15 0 0 1 0 30H30z' fill='%23fafafa'/%3E%3Cpath d='M45 0L30 15V0zM15 30L0 45v-15zM60 15L45 30V15zM30 45l15 15H30z' fill='%23f5f5f5'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: '60px 60px',
              minHeight: '320px'
            }}
          >
            {/* Close button */}
            <button 
              onClick={() => setShowQRCode(false)}
              className="absolute right-4 top-4 bg-gray-800 rounded-full w-8 h-8 flex items-center justify-center group hover:bg-gray-700 transition-colors"
            >
              <svg 
                className="w-4 h-4 text-white opacity-80 group-hover:opacity-100" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Logo */}
            <img src={logo} alt="Logo" className="h-5 absolute left-8 top-8" />

            {/* Content */}
            <div className="flex flex-col items-center justify-center h-full pt-10">
              <h3 className="text-lg font-bold mb-4">扫码关注公众号</h3>
              <img src={qrcode} alt="QR Code" className="w-36 h-36" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;